<template>
  <div class="markdown text-sm" v-html="useMarked(data?.text)" v-if="data?.text" />
</template>

<script setup>
const team = useTeamStore()

const props = defineProps({
  type: {
    type: String,
    default: ''
  }
})

const { data } = await useFetch(`/api/v1/seo`, { 
  key: `team-seo-${props.type}-${team.slug}`,
  baseURL: useEnv('apiBase'),
  query: {
    type: props.type,
    team: team.slug,
  }
})
</script>